
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluSSKCevap } from '@/plugins/uyap-plugin/uyap/DosyaBorcluSSK';

@Component({})
export default class SskAktifDetay extends Vue {
  @Prop() data!: DosyaBorcluSSKCevap;


  get sigortaliBilgi() {
    return this.data.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi;
  }

  get isyeriList() {
    return this.data.sorguSonucDVO?.isYeriBilgileri?.data?.sonuc?.isyeriTescil4AOzetArray || [];
  }

  get sgkIsyeriDVO() {
    return this.data.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO || {};
  }

  get hasData() {
    return this.data.sorguSonucDVO?.sskBilgiDetay ||
           (this.isyeriList && this.isyeriList.length > 0);
  }

  get vergiNo() {
    return this.isyeriList[0]?.teVergiNo || '';
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.$toast.success('Kopyalandı: ' + text);
    });
  }
}
